import { Avatar, Stack, Typography } from '@mui/material'
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid'
import { useDispatch } from 'react-redux'
import FlowApiClient from '../../backend/sub_api_clients/FlowApiClient'
import { IApprovalRequest } from '../../definitions/Approval'
import { IFlow } from '../../definitions/Nodes'
import Formatter from '../../helpers/Formatter'
import { changeRoute } from '../../store/slices/SessionSlice'
import useQuery, { buildQueryKey } from '../hooks/useQuery'
import StatusChip from './StatusChip'

const slots: any = { toolbar: GridToolbar }
const slotProps: any = {
    toolbar: {
        showQuickFilter: true,
        quickFilterProps: {
            variant: 'outlined',
            size: 'small'
        }
    },
    loadingOverlay: {
        variant: 'skeleton',
        noRowsVariant: 'skeleton'
    }
}
const sx = {
    '&.MuiDataGrid-root': {
        padding: 3,
        borderRadius: '12px'
    }, '& .MuiDataGrid-cell:focus': {
        outline: 'none'
    },
    '& .MuiDataGrid-cell:focus-within': {
        outline: 'none'
    }
}

const columns: GridColDef<any>[] = [
    { field: 'name', headerName: 'Engine name', flex: 1 },
    { field: 'version', headerName: 'Version', flex: 1, renderCell: params => params.row.versioning.version },
    { field: 'status', headerName: 'Approval status', flex: 1, renderCell: params => params.row?.approval?.status ? <StatusChip status={params.row.approval.status} /> : null },
    { field: 'lastModified', headerName: 'Last edit', flex: 1, renderCell: params => params.row?.lastModified ? Formatter.date(new Date(params.row.lastModified), 'mm/dd/yyyy hh:mm:ss') : null },
    { field: 'lastModifiedBy', headerName: 'Last edit by', flex: 1, renderCell: params => params.row?.user?.fullName
        ? (
                <Stack flexDirection='row' alignItems='center' gap={1} height='100%'>
                    <Avatar src={params.row.user.image} sx={{ width: 24, height: 24 }} />
                    <Typography variant='body2'>{params.row.user.fullName}</Typography>
                </Stack>
            )
        : null }
]

interface P {
    showPendingTemplates: boolean
}

const FlowTemplates = ({ showPendingTemplates }: P) => {
    const dispatch = useDispatch()

    const { status, response } = useQuery({
        queryKey: buildQueryKey(showPendingTemplates ? 'pendingEngines' : 'approvedEngines'),
        queryFn: () => showPendingTemplates ? FlowApiClient.getPendingFlowTemplates() : FlowApiClient.getApprovedFlowTemplates(),
        cache: true
    })

    const handleRowClick = (params: any) => {
        dispatch(changeRoute({ route: 'flow', params: { flowId: params.row.uuid } }))
    }

    const rows = response ?? [] as (IFlow & { approval?: Pick<IApprovalRequest, 'approvalEntityUUID' | 'status'> })[]

    return (
        <DataGrid
            loading={status === 'loading' || status === 'stale'}
            sx={sx}
            getRowId={row => row.uuid}
            columns={columns}
            rows={rows}
            slots={slots}
            slotProps={slotProps}
            hideFooter
            disableRowSelectionOnClick
            onRowClick={handleRowClick}
        />
    )
}

export default FlowTemplates
